import TermsPage from '@/views/leagal/TermsPage'

export default function Page() {
  return <TermsPage />
}
